import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {ReservationData} from "../../models/reservationData";
import {VoucherTemplate} from "../../models/voucherTemplate";


@Component({
    selector: 'additional-voucher-info-dialog',
    templateUrl: './additionalVoucherInfoDialog.component.html',
    styleUrls: ['./additionalVoucherInfoDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class AdditionalVoucherInfoDialogComponent {
    action: string;
    event: ReservationData;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    eventForm: FormGroup;
    voucher: VoucherTemplate;


    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<AdditionalVoucherInfoDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
    ) {
        this.voucher = _data.voucher;
        this.translationLoader.loadTranslations(polish);
    }
}
